import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../services/WiMuleSQL";

const fetchTodaysLunchMeal = async () => {
  const response = await axios.get(`${WiMuleSQL}/api/LunchMenu/GetTodaysMeal`);

  return response.data.data;
};

export const useGetTodaysLunchMeal = (enabled = true) =>
  useQuery({
    queryKey: ["TodaysLunchMeal"],
    queryFn: () => fetchTodaysLunchMeal(),
    enabled,
    staleTime: 1000 * 60 * 15, // 15 minutes
  });
